export default "__VITE_ASSET__DZFfcSba__"